import ProxyBase from '../../../../../../core/proxies/ProxyBase'

export class RecentNewsProxy extends ProxyBase {
  getRecentNewsTable(params) {
    return this.get('RecentNews', params)
  }
}

export default new RecentNewsProxy('IndustryOverview/')
